module.exports = __webpack_public_path__ + "media/components/assets/icons/label_hot-c2fa99ce26ed583a0e5c5b936b887a6f.svg";